import type { Category } from "@prisma/client";
import type { KebabCase } from "type-fest";

export const categories: {
  [K in Category]: {
    name: string;
    slug: KebabCase<K>;
    emoji: string;
    description: string;
  };
} = {
  ART_AND_MUSIC: {
    name: "Art & Music",
    slug: "art-and-music",
    emoji: "🎨",
    description:
      "Explore creativity through famous artists, musical legends, and timeless masterpieces.",
  },
  BUSINESS: {
    name: "Business",
    slug: "business",
    emoji: "📈",
    description:
      "From startups to stocks, dive into the world of business, finance, and entrepreneurship.",
  },
  SCIENCE: {
    name: "Science",
    slug: "science",
    emoji: "🧬",
    description:
      "Discover the wonders of biology, chemistry, physics, and beyond.",
  },
  SOCIAL_STUDIES: {
    name: "Social Studies",
    slug: "social-studies",
    emoji: "🏛",
    description:
      "Learn about societies, cultures, governments, and how people shape the world.",
  },
  GEOGRAPHY: {
    name: "Geography",
    slug: "geography",
    emoji: "🌎",
    description:
      "Explore continents, countries, landmarks, and natural wonders across the globe.",
  },
  HISTORY: {
    name: "History",
    slug: "history",
    emoji: "📜",
    description:
      "Step back in time to uncover key events, civilizations, and historical figures.",
  },
  LANGUAGE_ARTS: {
    name: "Language Arts",
    slug: "language-arts",
    emoji: "📖",
    description:
      "Improve your reading, writing, and literary knowledge with engaging language topics.",
  },
  MATH: {
    name: "Math",
    slug: "math",
    emoji: "🧮",
    description:
      "Solve equations, explore patterns, and master the world of numbers.",
  },
  TECHNOLOGY: {
    name: "Technology",
    slug: "technology",
    emoji: "🛰",
    description:
      "Stay ahead with topics on coding, innovation, and the latest tech breakthroughs.",
  },
  TEST_PREP: {
    name: "Test Prep",
    slug: "test-prep",
    emoji: "📚",
    description: "Sharpen your skills and get ready to ace your next big exam.",
  },
  TRIVIA: {
    name: "Trivia",
    slug: "trivia",
    emoji: "💡",
    description:
      "Put your knowledge to the test with fun facts and brain-teasing questions.",
  },
};
